import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../styles/shared";
import { property } from "lit/decorators/property.js";

@customElement("bs-section")
export class BsSection extends LitElement {
	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: flex;
					flex-direction: column;
					padding: var(--section-padding, 0 var(--space-l));
				}

				:host([width="thin"]) #container {
					max-width: var(--section-container-width, 700px);
				}

				:host([width="wide"]) #container {
					max-width: var(--section-container-width, 1200px);
				}

				#container {
					margin: 0 auto;
					max-width: var(--section-container-width, 1000px);
					width: 100%;
				}

				.grower {
					flex-grow: 1;
				}

				.grower:first-child {
					min-height: var(--section-space-top, var(--section-space, 140px));
				}

				.grower:last-child {
					min-height: var(--section-space-bottom, var(--section-space, 140px));
				}
			`
		];
	}

	@property({ type: String, reflect: true }) width: "thin" | "normal" | "wide" = "normal";

	renderContent() {
		return html`<slot></slot>`;
	}

	render() {
		return html`
			<div class="grower"></div>
			<div id="container">${this.renderContent()}</div>
			<div class="grower"></div>
		`;
	}
}
